import _ from "lodash";
import client from "lib/apolloClient/client";
import { getAssignmentAndDeadlineQuery } from "./AssignmentAndDeadlineQuery";

export const getAssignmentAndDeadlineQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getAssignmentAndDeadlineQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeAssignmentAndDeadlineQueryInCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getAssignmentAndDeadlineQuery,
      variables,
      data,
    });
  } catch (e) {}
};
